module.exports = __webpack_public_path__ + "media/noPineapple2.5ece5857.mp3";